module.exports = {"views.activatePartnerSuccess.heading":"Succès !","views.activatePartnerSuccess.body":"Votre abonnement a été activé avec succès."}


//////////////////
// WEBPACK FOOTER
// ./src/i18n/fr/views/ActivatePartnerSuccess.json
// module id = 784
// module chunks = 0